function ckeditorLinkConfig({ data }) {
  const dialogName = data.name;
  const dialogDefinition = data.definition;

  if (dialogName === 'link') {
    const infoTab = dialogDefinition.getContents('info');
    const linkOptions = infoTab.get('linkType');
    const protocolOptions = infoTab.get('protocol');

    linkOptions.items = [['URL', 'url']];
    linkOptions.hidden = true;

    protocolOptions.items = [['https://', 'https://'], ['http://', 'http://']];
    protocolOptions.default = 'https://';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.CKEDITOR.on('dialogDefinition', ckeditorLinkConfig);
});

export { ckeditorLinkConfig };
